import Vue from 'vue'
import VueRouter from 'vue-router'
//import home from '../views/home.vue'
//import sobre from "../views/sobre.vue"
import aviso from "../views/Aviso.vue"
import ayuda from "../views/ayuda.vue"
import loan from "../views/loan.vue"
//import privacy from "../views/privacy.vue"
import provision from "../views/provision.vue"
//import privacyagreement from "../views/privacyagreement.vue"
Vue.use(VueRouter)

// 避免重复导航当前路由时控制台报 NavigationDuplicated（如已在 /landing 再点 Logo）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}

const routes = [
  {
    path: '/',
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'home',
    component: () =>
        import(/* webpackChunkName: "marketing" */ '../views/marketing/LandingHtmlPage.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () =>
        import(/* webpackChunkName: "marketing" */ '../views/marketing/FaqHtmlPage.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: aviso
  },
  {
    path: '/help',
    name: 'help',
    component: ayuda
  },
  {
    path: '/loan',
    name: 'loan',
    component: loan
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () =>
        import(/* webpackChunkName: "marketing" */ '../views/marketing/PrivacyNoticeHtmlPage.vue')
  },
  {
    path: '/pricacyagreement',
    name: 'pricacyagreement',
    component: () =>
        import(/* webpackChunkName: "marketing" */ '../views/marketing/PrivacyNoticeHtmlPage.vue')
  },
  {
    path: '/provision',
    name: 'provision',
    component: provision
  },
  {
    path: '/landing',
    name: 'landingHtml',
    component: () =>
      import(/* webpackChunkName: "marketing" */ '../views/marketing/LandingHtmlPage.vue')
  },
  {
    path: '/centro-ayuda',
    name: 'centroAyudaHtml',
    component: () =>
      import(/* webpackChunkName: "marketing" */ '../views/marketing/FaqHtmlPage.vue')
  },
  {
    path: '/aviso-de-privacidad',
    name: 'avisoPrivacidadHtml',
    component: () =>
      import(/* webpackChunkName: "marketing" */ '../views/marketing/PrivacyNoticeHtmlPage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
